import type { ReactNode } from 'react'

/** Подпись + input/select/textarea (form-field wrapper). */
export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label className="block mb-3">
      <div className="text-sm font-medium text-gray-700 mb-1">{label}</div>
      {children}
    </label>
  )
}
